/* Copyright (c) 2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SystemInfoKey } from 'crimson/lib/system-info-service/system-info.models';
import { SystemInfoService } from 'crimson/lib/system-info-service/system-info.service';
import { NoOpGamepadService } from './no-op-gamepad.service';

export class AndroidGamepadService extends NoOpGamepadService {
    constructor(private systemInfoService: SystemInfoService) {
        super();
    }

    public get isGamepadConnected$(): Observable<boolean> {
        const isHIDGamepadConnected$ = this.systemInfoService
            .getSystemInfo([SystemInfoKey.HID])
            .pipe(map(systemInfo => systemInfo?.HID?.GamePad?.length > 0));

        return isHIDGamepadConnected$;
    }
}
